/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
const getDataLayer = () => {
    if (!(window as any).dataLayer) {
        (window as any).dataLayer = [];
    }

    return (window as any).dataLayer;
};

export { getDataLayer };

/* eslint-disable */
(function (window) {
    (window as any)._GaCheckoutFunnel = (
        cart: any,
        step: any,
        eventName: string,
        includeBrand: boolean,
        includeCategory: boolean,
    ) => {
        const dataLayer = getDataLayer();
        if (!dataLayer) {
            return;
        }

        const data: any = {
            event: eventName || "checkout",
            ecommerce: {
                checkout: {
                    actionField: { step },
                    products: [],
                },
            },
        };

        cart?.cartLines?.map((cartLine: any) => {
            const GAData = {
                name: cartLine.shortDescription,
                id: cartLine.erpNumber,
                price: cartLine?.pricing?.unitNetPrice || 0,
                quantity: cartLine.qtyOrdered,
            } as any;

            if (includeBrand) {
                GAData["brand"] = cartLine.brand?.name || "";
            }

            if (includeCategory) {
                GAData["category"] = cartLine.properties["category"];
            }

            data.ecommerce.checkout.products.push(GAData);
        });
        dataLayer.push(data);
    };
})(typeof window != "undefined" ? window : {});
/* eslint-enable */
